export const SERVER_MESSAGE_RESPONSE_CONTENT_PARAGRAPH =
    'server-message-response-content--paragraph';
export const SERVER_MESSAGE_RESPONSE_CONTENT_UNORDERED_LIST =
    'server-message-response-content--unordered-list';
export const SERVER_MESSAGE_RESPONSE_CONTENT_ORDERED_LIST =
    'server-message-response-content--ordered-list';
export const SERVER_MESSAGE_RESPONSE_CONTENT_LIST =
    'server-message-response-content--list';
export const SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_1 =
    'server-message-response-content--header-1';
export const SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_2 =
    'server-message-response-content--header-2';
export const SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_3 =
    'server-message-response-content--header-3';
export const SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_4 =
    'server-message-response-content--header-4';
export const SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_5 =
    'server-message-response-content--header-5';
export const SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_6 =
    'server-message-response-content--header-6';
export const SERVER_MESSAGE_RESPONSE_CONTENT_PDF_LINK =
    'server-message-response-content--pdf-link';
export const NOTIFICATION_GROUP_CONTAINER = 'notification-group-container';
export const CANVAS_CONTENT_CLASS = 'bxf-chat-canvas__content';

export const CLASSNAME_OVERRIDE_MAP = {
    ol: SERVER_MESSAGE_RESPONSE_CONTENT_ORDERED_LIST,
    ul: SERVER_MESSAGE_RESPONSE_CONTENT_UNORDERED_LIST,
    li: SERVER_MESSAGE_RESPONSE_CONTENT_LIST,
    p: SERVER_MESSAGE_RESPONSE_CONTENT_PARAGRAPH,
    h1: SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_1,
    h2: SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_2,
    h3: SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_3,
    h4: SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_4,
    h5: SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_5,
    h6: SERVER_MESSAGE_RESPONSE_CONTENT_HEADER_6,
};

export default CLASSNAME_OVERRIDE_MAP;
